import { render } from "./MaterialCheckbox.vue?vue&type=template&id=48de7d4e"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import "./MaterialCheckbox.vue?vue&type=style&index=0&id=48de7d4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__